/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React from 'react';

export default function MoreInformation({ OrderDetails }) {
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
            }}
            id="moreDetails"
            role="tooltip"
            className="inline-block absolute visible z-[99] px-[18px] pt-3 pb-4 border border-[#CBC7C7] bg-[#F5F5FA] rounded-lg shadow-s2 sm:min-w-[304px] w-[250px]"
        >
            <p className="text-xs2 font-bold text-[#000000]">Company Details</p>
            <div className="pt-2.5">
                <p className="text-xs3 font-semibold text-[#808285]">Mobile Number</p>
                <p className="pt-0.5 text-sm font-normal text-[#090406]">{OrderDetails?.PRIMARY_PHONE_NUMBER || '-'}</p>
            </div>
            <div className="pt-3.5">
                <p className="text-xs3 font-semibold text-[#808285]">Email Address</p>
                <p className="pt-0.5 text-sm font-normal text-[#090406]">{OrderDetails?.EMAIL_ADDRESS}</p>
            </div>
            <div className="flex -mx-0.5 pt-3.5">
                <div className="px-0.5 w-1/2">
                    <p className="text-xs3 font-semibold text-[#808285]">GSTIN</p>
                    <p className="pt-0.5 text-sm font-normal text-[#090406]">{OrderDetails?.GSTIN || '-'}</p>
                </div>
                <div className="px-0.5 w-1/2">
                    <p className="text-xs3 font-semibold text-[#808285]">PAN Number</p>
                    <p className="pt-0.5 text-sm font-normal text-[#090406]">{OrderDetails?.PAN_NUMBER || '-'}</p>
                </div>
            </div>
            <div className="tooltip-arrow" data-popper-arrow />
        </motion.div>
    );
}
